module.exports = __webpack_public_path__ + "img/thumbnail_ManedWolf_j_normal.3be7b190.png";